import { BaseResource } from './base-resource';

export class LoyaltyBadgeItem extends BaseResource {
  readonly code: string;
  readonly displayName: string;
  readonly imageUrl?: string;
  readonly dateOrdered?: string;
  readonly imageLastUpdated?: string;
}
